import React, { useState, useEffect } from 'react';
import './Pages.css';

const NewPolicies = ({ setActiveMenu }) => {
  const [policies, setPolicies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    fetchNewPolicies();
  }, []);

  const fetchNewPolicies = async () => {
    try {
      const response = await fetch('https://main.victriedemos.com:3017/api/policies/status/2');
      const data = await response.json();

      if (data.success) {
        setPolicies(data.data);
      } else {
        setError('Failed to load new policies');
      }
    } catch (err) {
      console.error('Error fetching new policies:', err);
      setError('Unable to connect to server');
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return 'N/A';
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
  };

  const formatCurrency = (amount) => {
    if (!amount) return 'N/A';
    return new Intl.NumberFormat('en-KE', {
      style: 'currency',
      currency: 'KES'
    }).format(amount);
  };

  const handleAmendPolicy = (policyId) => {
    // Navigate to edit/amend policy page
    setActiveMenu('edit-policy', policyId);
  };

  const handleForwardForApproval = async (policy) => {
    if (!window.confirm(`Forward policy ${policy.PolicyNumber} for approval?`)) {
      return;
    }

    try {
      const userEmail = localStorage.getItem('userEmail');
      
      const response = await fetch('https://main.victriedemos.com:3017/api/policies/forward-approval', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          policyId: policy.PolicyIdNo,
          forwardedBy: userEmail
        })
      });

      const data = await response.json();

      if (data.success) {
        alert('✅ Policy forwarded for approval successfully!');
        fetchNewPolicies(); // Refresh the list
      } else {
        alert('❌ Failed to forward policy: ' + data.message);
      }
    } catch (err) {
      console.error('Error forwarding policy:', err);
      alert('❌ An error occurred while forwarding policy');
    }
  };

  const filteredPolicies = policies.filter(policy => {
    if (!searchTerm) return true;
    
    const search = searchTerm.toLowerCase();
    const clientName = (policy.ClientName || '').toLowerCase();
    const policyNumber = (policy.PolicyNumber || '').toLowerCase();
    const registration = (policy.Registration || '').toLowerCase();
    
    return clientName.includes(search) || policyNumber.includes(search) || registration.includes(search);
  });

  if (loading) {
    return (
      <div className="page-container">
        <div className="loading-container">
          <div className="spinner"></div>
          <p>Loading new policies...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <h1>📝 New Policies</h1>
          <p className="page-subtitle">Policies pending submission for approval</p>
        </div>
        <button 
          className="primary-btn"
          onClick={() => setActiveMenu && setActiveMenu('create-policy')}
        >
          ➕ New Policy
        </button>
      </div>

      {error && (
        <div className="error-banner">
          {error}
        </div>
      )}

      <div className="search-bar">
        <input
          type="text"
          placeholder="🔍 Search by Client Name, Policy Number, or Registration..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />
        {searchTerm && (
          <button 
            className="clear-search-btn"
            onClick={() => setSearchTerm('')}
          >
            ✕ Clear
          </button>
        )}
      </div>

      <div className="table-container">
        {filteredPolicies.length === 0 ? (
          <div className="empty-state">
            <p>{searchTerm ? `No policies found matching "${searchTerm}"` : 'No new policies found'}</p>
          </div>
        ) : (
          <table className="data-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Policy Number</th>
                <th>Client Name</th>
               
                <th>Registration</th>
                <th>Product Name</th>
                <th>Cover Type</th>
                <th>Underwriter</th>
                <th>Gross Premium</th>
                <th>Date Created</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredPolicies.map((policy, index) => (
                <tr key={policy.PolicyIdNo}>
                  <td>{index + 1}</td>
                  <td className="policy-number">{policy.PolicyNumber || 'N/A'}</td>
                  <td className="client-name">{policy.ClientName}</td>

                  <td>{policy.Registration || 'N/A'}</td>
                  <td>{policy.ProductName || 'N/A'}</td>
                  <td>{policy.CoverType || 'N/A'}</td>
                  <td>{policy.UnderwriterName || 'N/A'}</td>
                  <td className="amount">{formatCurrency(policy.GrossPremium)}</td>
                  <td>{formatDate(policy.DateCreated)}</td>
                  <td>
                    <button
                      className="action-icon-btn"
                      title="Amend Policy"
                      onClick={() => handleAmendPolicy(policy.PolicyIdNo)}
                    >
                      ✏️
                    </button>
                    <button
                      className="action-icon-btn approve-btn"
                      title="Forward for Approval"
                      onClick={() => handleForwardForApproval(policy)}
                    >
                      ➡️
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default NewPolicies;
